import { Component } from '@angular/core'

@Component({
   selector: 'app-spinner',
   template: `<div class="spinner-wrapper"><div class="bg-pno-spinner w-[128px] h-[128px] spinner-logo"></div></div>`,
})
export class SpinnerComponent {}

